<template>
    <svg class='svg svg--nav svg--nav--diamond-small-single' width='52' height='20' viewBox='0 0 52 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <line x1='26' y1='0' x2='26' y2='20' class='svg--nav__stroke' stroke-width='0.5' vector-effect='non-scaling-stroke' />
        <path d='M33 10C30.6667 10 26 16.6667 26 20C26 16.6667 21.3333 10 19 10C21.3333 10 26 3.33333 26 0C26 3.33333 30.6667 10 33 10Z' class='svg--nav__fill' />
    </svg>
</template>